export function getBaseURL() {
  let base = ''

  if (window.location.hostname.indexOf('localhost') >= 0) {
    base = window.location.origin + getLocalPath()
  } else {
    base = window.location.origin
  }

  return base
}

function getLocalPath() {
  const pathname = window.location.pathname
  let path = ''

  if (pathname.indexOf('cti-advisorspa') >= 0) {
    path = '/cti-site/cti-advisorspa'
  } else if (pathname.indexOf('cti-advisor-spa') >= 0) {
    path = '/cti-site/cti-advisor-spa'
  } else if (pathname.indexOf('cti-advisor') >= 0) {
    path = '/cti-site/cti-advisor'
  } else if (pathname.indexOf('cti-investorspa') >= 0) {
    path = '/cti-site/cti-investorspa'
  } else if (pathname.indexOf('cti-investor') >= 0) {
    path = '/cti-site/cti-investor'
  } else if (pathname.indexOf('cti-institutional') >= 0) {
    path = '/cti-site/cti-institutional'
  } else if (pathname.indexOf('blogspa') >= 0) {
    path = '/cti-site/blogspa'
  }

  return path
}

export function isLocal() {
  return window.location && window.location.hostname.indexOf('localhost') >= 0
}

export function getAdvisorPathIfLocal() {
  return isLocal() ? '/cti-site/cti-advisor' : ''
}

export function getInvestorPathIfLocal() {
  return isLocal() ? '/cti-site/cti-investor' : ''
}

export function getInstitutionalPathIfLocal() {
  return isLocal() ? '/cti-site/cti-institutional' : ''
}

export function getBlogPathIfLocal() {
  return isLocal() ? '/cti-site/blogspa' : '/insights/latest-insights'
}

export function isPreview() {
  return window.location && window.location.pathname.indexOf('/preview') >= 0
}
